export const SEARCH_FORM = {
  ref: "search_invoice",
  name: "search_invoice",
  id: "search_invoice",
  label: "Invoice No. / ITR No. / Device",
  span: 6,
};

export const SEARCH_FORM_DEVICE_ID = {
  ref: "search_device_id",
  name: "search_device_id",
  id: "search_device_id",
  label: "Device No.",
  span: 6,
};
